module.exports = __webpack_public_path__ + "img/jianjie.90c3c071.png";